<template>
<div class="row">
    <div class="col pt-1 pb-3">

        <div class="text-center pt-3 pb-1"><h5 class="mt-0 pt-4 homepage-heading border-top">Join the conversation</h5></div>

        <div class="text-center py-3 sticky-top mb-2" style="background-color:#fff;">
          <a href="#/" @click="showNewCommentModal()" class="new-comment" v-if="user.id">New Comment</a>
                  <div class="new-comment" v-else>Please <b><a href="/register">register</a></b> or <b><a href="/login">login</a></b> to comment</div>
          <span v-if="loading"><i class="fas fa-spinner fa-spin fa-1x ml-2 mt-2 new_loader"></i></span>
          <a v-else-if="refreshMessage" href="#/" @click="getComments()" class="new-comment dark ml-2 px-3 py-2"><i class="fa-solid fa-arrow-up mr-2"></i>{{refreshMessage}}</a>
        </div>

        <new-comment @get-comments="getComments" @get-articles="getArticles" :article="article"></new-comment>
        <edit-comment :comment="selectedComment" @get-comments="getComments" @get-articles="getArticles"></edit-comment>

        <div class="text-center" v-if="!loading && loadedComments.length == 0">
          <!-- No comments yet -->
        </div>
        
        <div v-else class="row px-0 px-md-3 comment_box" v-for="(comment, index) in loadedComments" :key="index.id">
          <div class="col-1 pt-2" style="width:32px;"><img :src="getAvatar(comment.user)" class="comment_image"></div>
          <div class="col-10 col-md-11 pl-4 pl-md-0 ml-2 ml-md-0">
              <div class="comment_author"><span class="comment_name">{{comment.user.name}}</span><span class="comment_time"><timeago
                        :datetime="comment.created_at"
                        :auto-update="60"
                        :title="formatDateMoment(comment.created_at)"></timeago>
                        </span></div>
                        <div class="comment_time" v-if="user.id === comment.user.id"> 
                          <span class="mr-3"><a href="#/" class="comment_action" @click="showEditCommentModal(comment)">Edit</a></span> 
                          <a href="#/" class="comment_action" @click="deleteComment(comment.id)">Delete</a>
                        </div>
                        <div
                        v-html="comment.content"
                        v-linkified
                        class="comment_text" />
          </div>
      </div>

    </div>
</div>
</template>

<script>
export default {
  props: ['article','user'],

  data() {
    return {
      loadedComments: [],
      newComments: [],
      commentDiff: 0,
      refreshMessage: null,
      loading: false,
      selectedComment: {},
    };
  },

  created() {
    this.getComments();
      Echo.channel("comments_" + this.article.id)
      .listen("UpdateComments", () => {
        this.countComments();
      });

  },

  methods: {

    scrollTop() {
      this.$emit('scroll-top');
    },

    getArticles() {
      this.$emit('get-articles');
    },

    deleteComment(id) {

      Swal.fire({
      title: 'Are you sure you want to delete this comment?',
      showConfirmButton: false,
      showDenyButton: true,
      showCancelButton: true,
      focusConfirm: false,
      denyButtonText: 'Yes, delete it',
      customClass: {
              title: "popup-title",
            },
    }).then((result) => {

    if (result.isDenied) {
        
        this.deleteCommentAction(id);

      } 

    })

    },

    deleteCommentAction(id) {

      let existingObj = this;

      axios
        .post('/comment/update', {id: id, action: 'delete'})
        .then(function (response) {

          if (response.data.success) {
            existingObj.getComments();
            existingObj.getArticles();
          } else {
            existingObj.sweetfire(response.data.message);
          }

        });

    },

    showNewCommentModal() {
      this.$bvModal.show('bv-new-comment');
    },

    showEditCommentModal(comment) {
      this.selectedComment = comment;
      this.$bvModal.show('bv-edit-comment');
    },

   getComments() {

      this.loading = true;

      axios.post('/comment/get', {
        article_id: this.article.id
      }).
      then((response) => {
        this.loadedComments = response.data;
        this.newComments = [];
        this.commentDiff = 0;
        this.refreshMessage = null;
        this.loading = false;
      });
    },

    countComments() {

      axios.post('/comment/get', {
        article_id: this.article.id
      }).
      then((response) => {

        this.newComments = response.data;

        this.commentDiff = this.newComments.length - this.loadedComments.length;

        if ( this.commentDiff > 0) {
          // new
          this.refreshMessage = this.commentDiff + ' new';
        } 
        
        else if (this.commentDiff < 0) {
          // deleted
          this.refreshMessage = Math.abs(this.commentDiff) + ' deleted';
        } 
        
        
        else if ((this.newComments.length == this.loadedComments.length) && (JSON.stringify(this.newComments) !== JSON.stringify(this.loadedComments))) { 
          // updated
          this.refreshMessage = 'refresh';

        } else {
          this.refreshMessage = null;
        }

      });
    },

    getAvatar(user) {
      return (user.avatar) ?? '/images/default_user.png';
    },

    showToaster(text) {
      this.$toaster.info(text, { timeout: 2500 });
      },

    sweetfire(text) {

      Swal.fire({
          timer: 2000,
          title: text,
          showConfirmButton: false,
        customClass: {
              title: "popup-title",
            }});

    },

  }

}
</script>